exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-settings-parameters .modal-dialog {\n  width: 386px !important; }\n", ""]);

